import { roomTypes, typeTravler } from "../../../Constants/types";
import PricesPackageTable from "./table.js/table";

const PricesPackage = ({ model, setModel }) => {
  const handlePriceChange = (
    hotelName,
    arrangementName,
    typeTraveler,
    field,
    value
  ) => {
    const updatedPrices = model.prices.map((price) => {
      if (
        price.name === hotelName &&
        price.arrangementName === arrangementName &&
        price.typeTraveler === typeTraveler
      ) {
        return { ...price, [field]: value };
      }
      return price;
    });

    setModel((prev) => ({ ...prev, prices: updatedPrices }));
  };

  const handleDeletePrice = (hotelName, arrangementName) => {
    const updatedPrices = model.prices.filter(
      (price) =>
        !(price.name === hotelName && price.arrangementName === arrangementName)
    );

    setModel((prev) => ({ ...prev, prices: updatedPrices }));
  };

  const groupedPrices = (prices) => {
    return prices.reduce((acc, price) => {
      const hotelGroup = acc[price.name] || {};
      hotelGroup[price.arrangementName] =
        hotelGroup[price.arrangementName] || [];
      hotelGroup[price.arrangementName].push(price);
      acc[price.name] = hotelGroup;
      return acc;
    }, {});
  };

  const handleAddPrice = (hotelName) => {
    const hotel = model.destinations
      .flatMap((destination) => destination.hotelsVo)
      .find((hotel) => hotel.name === hotelName);

    if (!hotel) return;

    const hotelId = hotel.hotelListId;

    const existingArrangements = model.prices
      .filter((price) => price.name === hotelName)
      .map((price) => price.arrangementName);

    const missingRoomTypes = roomTypes.filter(
      (roomType) => !existingArrangements.includes(roomType.value)
    );

    const newPrices = missingRoomTypes.flatMap((roomType) =>
      typeTravler.map((traveler) => ({
        name: hotelName,
        price: 0,
        typeTraveler: traveler.value,
        arrangementName: roomType.value,
        hotelListIds: [hotelId],
        costs: [],
      }))
    );

    setModel((prevModel) => ({
      ...prevModel,
      prices: [...prevModel.prices, ...newPrices],
    }));
  };

  return (
    <div className="p-10">
      <PricesPackageTable
        prices={groupedPrices(model.prices)}
        onPriceChange={handlePriceChange}
        onDeletePrice={handleDeletePrice}
        onAddPrice={handleAddPrice}
      />
    </div>
  );
};

export default PricesPackage;
